import store from "../store";

export default {
    onUseThis(code: string) {
        const taxCodeDetailsFromStore = store.getters.taxcode(code)
        const taxcodeDetail = {
            code: taxCodeDetailsFromStore.code,
            desc: taxCodeDetailsFromStore.description,
            /* eslint-disable @typescript-eslint/camelcase */
            short_desc: taxCodeDetailsFromStore.description
            /* eslint-enable @typescript-eslint/camelcase */
        };
        window.parent.postMessage(JSON.stringify(taxcodeDetail), "*");
    }
}